import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";

import Layout from "../../../../layout/layout";
import useSkeleton from "../../../../hooks/useSkeleton";

import { loadingState } from "../../../../states/loadingState";

import BeneficiariesCredits from "./beneficiariesCreditsList";
import BeneficiariesApplications from "./beneficiariesApplications";

import { BlockUI } from "primereact/blockui";
import { Button } from "primereact/button";

const Beneficiaries = () => {
  const s = useSkeleton("abm");
  const { t } = useTranslation();

  const [isLoading] = useAtom(loadingState);

  return (
    <Layout>
      <div className="flex flex-column">
        <div className="flex flex-wrap align-items-center justify-content-center">
          <div className="flex justify-content-between align-items-center surface-overlay border-round border-1 shadow-1 p-5 py-0 m-3 w-7">
            <div>
              <span className="vertical-align-middle">
                {localStorage.getItem("personName")}
              </span>
            </div>
            <div>
              <Button link label="Modificar mis datos" className="mb-1" />
            </div>
          </div>
        </div>
        <div className="flex flex-wrap align-items-center justify-content-center">
          <div
            className="flex justify-content-between align-items-center 
            surface-overlay border-round border-1 shadow-1 p-5  m-3 w-7"
          >
            <BeneficiariesCredits />
          </div>
        </div>
        <div className="flex flex-wrap align-items-center justify-content-center">
          <div
            className="flex justify-content-between align-items-center 
            surface-overlay border-round border-1 shadow-1 p-5  m-3 w-7"
          >
            <BeneficiariesApplications />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Beneficiaries;
